import { store } from '../../../utils/userStore';
import { LEPRECHAUN_SUFFIX } from '../../../constants';
import WindowManager from '../../../utils/windowManager';
import { completionStatus } from '../../../constants/transactionStatus';
import {
  addTransactionListeners,
  handleErrorResponse,
} from '../transactionHelpers';
import { fetchBrokerConfig } from '../../../utils/brokerConfig';
import NonTransactionalIntent from '../../../constants/nonTransactionalIntents';
import { IntentHandler } from '../intentHandlerTypes';

const intentHandler: IntentHandler<NonTransactionalIntent.BROKER_LOGOUT> = {
  handleBrokerPlatform: async ({ broker }) => {
    const brokerConfig = fetchBrokerConfig(broker);

    const intentURL = brokerConfig.getIntentURL({
      intent: NonTransactionalIntent.BROKER_LOGOUT,
      broker,
      openMode: brokerConfig.transactionOpenMode,
      gateway: store.gateway,
      gatewayName: store.displayName,
    });

    await WindowManager.closeSecondary();

    const secondaryURL = `pre-connect/?broker=${broker.replace(
      LEPRECHAUN_SUFFIX,
      '',
    )}`;
    const completionPromise = addTransactionListeners({
      broker,
    });

    await WindowManager.openIndirect({
      primaryURL: intentURL,
      primaryWindowType: brokerConfig.transactionOpenMode,
      secondaryStatus: secondaryURL,
      broker,
      intent: NonTransactionalIntent.BROKER_LOGOUT,
    });

    return {
      shouldReturn: false,
      completionPromise,
    };
  },
  async handleCompletion({ message }) {
    await WindowManager.closePrimary();

    await WindowManager.closeAll();

    if (message.data.status === completionStatus.ERRORED) {
      return handleErrorResponse(message);
    }

    return true;
  },
};

export default intentHandler;
